import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // eslint-disable-next-line no-console
  console.error("Supabase env vars missing. Check REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY.");
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: "inonit-auth",
  },
});

// Map auth API errors / Postgres errors to a friendly string.
export function fmtError(err) {
  if (!err) return "Something went wrong.";
  if (typeof err === "string") return err;
  return err.message || err.error_description || "Something went wrong.";
}
